import type { FC } from 'react'
import { ListItem, UnorderedList, VStack } from '@chakra-ui/react'
import type { FooterItem } from 'ecosystem'
import { hrefFromAppPaths } from 'shared-utils'
import GrandHeading from 'ui/common/GrandHeading'
import GrandText from 'ui/common/GrandText'
import { GrandLink } from 'ui/common'
import { useAppPaths } from 'ui/hooks'
import { footerClassNames } from './footerTheme'

interface IFooterColumn {
  item: FooterItem
}

export const FooterColumn: FC<IFooterColumn> = ({ item }) => {
  const appPaths = useAppPaths()

  return (
    <VStack
      className={footerClassNames.column}
      alignItems={{ base: 'flex-start' }}
      alignSelf="flex-start"
      flexGrow={1}
    >
      <GrandHeading
        className={footerClassNames.sectionTitle}
        as="h2"
        containerProps={{
          my: 0
        }}
        fontSize={['lg', 'xl']}
        textAlign="left"
        // Uppercasing in CSS rather than in JS so the store theme can override it
        // through `components.CustomFooter.sectionTitle.textTransform`.
        textTransform="uppercase"
        title={item.sectionTitle}
        width={['100%']}
      />
      <UnorderedList listStyleType="none" p={0} spacing={1} className={footerClassNames.items}>
        {item.items.map((i, index) => (
          <ListItem key={index}>
            <VStack alignItems="flex-start" fontSize={['xs', 'sm']} spacing={1}>
              {i.label ? (
                <GrandText
                  className={footerClassNames.itemLabel}
                  color="text.default"
                  fontWeight="bold"
                  w="auto"
                >
                  {i.label}
                </GrandText>
              ) : null}

              {i.text && i.pathObj ? (
                <GrandLink
                  _focus={{ outline: 'none' }}
                  aria-label={i.text}
                  className={footerClassNames.itemLink}
                  href={hrefFromAppPaths(i.pathObj, appPaths)}
                  isExternal={i.isExternal}
                >
                  {i.text}
                </GrandLink>
              ) : (
                <GrandText className={footerClassNames.itemText} w="auto">
                  {i.text}
                </GrandText>
              )}
            </VStack>
          </ListItem>
        ))}
      </UnorderedList>
    </VStack>
  )
}
